<!-- OTP-Verification-Component.html -->
<div class="otp-verification-container">
  <div class="otp-header">
    <h2>Verification Code</h2>
    <span class="close-btn" mat-icon-button aria-label="Close dialog">
    <i class="ri-close-large-line"></i>
    </span>
  </div>
  
  <div class="otp-content">
    <div class="otp-icon">
        <span style="font-size: 30px;"> <i class="ri-lock-fill"></i> </span>
    </div>
    
    <p class="otp-message">
      We have sent a verification code to your registered mobile number
      <strong>{{this.data?.agentPhone}}</strong>
    </p>
    
      <div class="otp-input-container">
      <div class="otp-input-boxes" (paste)="handlePaste($event)">
        <input type="text" maxlength="1" pattern="[0-9]*" inputmode="numeric" class="otp-input" #otp1 (keyup)="onKeyUp($event, 0, otp2)" autofocus>
        <input type="text" maxlength="1" pattern="[0-9]*" inputmode="numeric" class="otp-input" #otp2 (keyup)="onKeyUp($event, 1, otp3)">
        <input type="text" maxlength="1" pattern="[0-9]*" inputmode="numeric" class="otp-input" #otp3 (keyup)="onKeyUp($event, 2, otp4)">
        <input type="text" maxlength="1" pattern="[0-9]*" inputmode="numeric" class="otp-input" #otp4 (keyup)="onKeyUp($event, 3, otp5)">
        <input type="text" maxlength="1" pattern="[0-9]*" inputmode="numeric" class="otp-input" #otp5 (keyup)="onKeyUp($event, 4, otp6)">
        <input type="text" maxlength="1" pattern="[0-9]*" inputmode="numeric" class="otp-input" #otp6 (keyup)="onKeyUp($event, 5)">
      </div>
    </div>
    
    <div class="otp-timer" *ngIf="false">
      <span>Code expires in: </span>
      <span class="countdown">{{ minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }}</span>
    </div>
    
    <div class="otp-resend">
      <span>Didn't receive the code?</span>
      <button 
        class="resend-btn" 
        [disabled]="!canResend" 
        (click)="resendOtp()">
        {{ canResend ? 'Resend OTP' : 'Resend in ' + (resendTimeLeft < 10 ? '0' + resendTimeLeft : resendTimeLeft) + 's' }}
      </button>
    </div>
  </div>
  
  <div class="otp-actions">
    <button  class="cancel-btn" (click)="onCancel()">Cancel</button>
    <button 
      
      class="verify-btn" 
      [disabled]="!isOtpComplete" 
      (click)="verifyOtp()">
      Verify
    </button>
  </div>
</div>